import React, { useEffect } from 'react';
import { Layout } from 'antd';
import { Outlet, useLocation } from 'react-router-dom';
import useThemeStore from '../../store/themeStore';

const { Content } = Layout;

const AuthLayout = () => {
  const { initializeTheme } = useThemeStore();

  useEffect(() => {
    initializeTheme();
  }, [initializeTheme]);

  // Both login and register now use full-width 2-column layout
  return (
    <Layout className="min-h-screen w-full">
      <Content className="w-full h-full">
        <Outlet />
      </Content>
    </Layout>
  );
};

export default AuthLayout;
